export default __webpack_public_path__ + "static/media/posteraudio.e458b9da.png";